export default {
  getRecentSearchKeyword(state) {
    return state.recentSearchKeywordList.slice(0, 10);
  },

  getRecommendedKeyword(state) {
    return state.recommendedKeywordList;
  },

  getKeywordRank(state) {
    return state.keywordRankList;
  },

  getFilter(state) {
    return state.filter;
  }
};
